import { HEADINGS_DROPDOWN_TYPE as type } from "./types.js";
const DEFAULTS = Object.freeze({
  type,
  config: {}
});
export {
  DEFAULTS
};
//# sourceMappingURL=defaults.js.map
